import React from "react";

import { useIntl } from "react-intl";
import { useTheme } from "styled-components";

import { AddButton } from "ds/Button";
import useDecodedParams from "Hooks/useDecodedParams";
import Illustration from "Vendor_resources/images/empty-integrations.svg";
import IllustrationDark from "Vendor_resources/images/empty-integrations_dark.svg";

import * as S from "./EmptyIntegrations.styles";

const EmptyIntegrations = () => {
  const { projectId, organizationId } = useDecodedParams<{
    projectId: string;
    organizationId: string;
  }>();
  const intl = useIntl();
  const theme = useTheme();

  const integrationSetupRoute = `/${organizationId}/${projectId}/-/settings/integrations/setup`;

  return (
    <S.Wrapper>
      <S.ImageWrapper>
        <img
          src={theme.name === "dark" ? IllustrationDark : Illustration}
          alt={intl.formatMessage({ id: "integrations.no_integration" })}
        />
      </S.ImageWrapper>
      <S.Title tag="h2">
        {intl.formatMessage({
          id: "integrations.no_integration",
          defaultMessage: "No integrations"
        })}
      </S.Title>
      <p>
        {intl.formatMessage({
          id: "integrations.add_integration_to_project",
          defaultMessage:
            "Connect git services, health checks, or webhoooks to your project"
        })}
      </p>
      <AddButton to={integrationSetupRoute} analyticId="integrations.add">
        {intl.formatMessage({
          id: "integrations.add",
          defaultMessage: "Add integration"
        })}
      </AddButton>
    </S.Wrapper>
  );
};

export default EmptyIntegrations;
